export default {"src":"/_next/static/media/globe.4cbebd2d.svg","height":20,"width":21};